import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import apiService from "../../../service/Api";

interface VenueStats {
  pending: number;
  assigned: number;
  completed: number;
  [key: string]: number; // in case you have more statuses
}

const StatusCards: React.FC = () => {
  const [stats, setStats] = useState<VenueStats | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await apiService.get<VenueStats>(
          "/api/venues/site-visit/statistics/"
        );
        setStats(response.data);
      } catch (err: unknown) {
        console.error(err);
        setError("Failed to fetch site visit statistics.");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" my={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" my={3}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card sx={{ boxShadow: 0 }}>
          <CardContent>
            <Typography variant="subtitle2">Pending Site Visits</Typography>
            <Typography variant="h5">{stats?.pending || 0}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card sx={{ boxShadow: 0 }}>
          <CardContent>
            <Typography variant="subtitle2">Assigned Site Visits</Typography>
            <Typography variant="h5">{stats?.assigned || 0}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card sx={{ boxShadow: 0 }}>
          <CardContent>
            <Typography variant="subtitle2">Completed Site Visits</Typography>
            <Typography variant="h5">{stats?.completed || 0}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <Card sx={{ boxShadow: 0, height: "100%" }}>
          <CardContent>
            <Typography variant="subtitle2">Other Status</Typography>
            <Typography variant="h5">{stats?.other || 0}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StatusCards;
